import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'
import { QuantumMetricsEventObject } from 'src/app/_models/analytics'
import { ENVIRONMENT, DDActions, API } from 'src/app/_constants/app.constants'


import { LoggerService } from '../../ui/logger/logger.service'
import { AppModule } from 'src/app/app.module'
import { SharedModule } from "src/app/_components/shared.module";
import { ServiceModule } from 'src/app/_services/service.module';
import { AuthService } from '../../api/auth/auth.service'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { catchError, of } from 'rxjs'
// import tracer from 'dd-trace';

@Injectable({
  providedIn: ServiceModule,
})
export class AnalyticsService {

  // private quantumMetricAPI: any
  private initialized: boolean = false

  constructor(
    private logger: LoggerService,
    private authService: AuthService,
    private http: HttpClient,
    @Inject(DOCUMENT) private document: any
  ) { }

  initTracer() {
    this.logger.debug('AnalyticsService.initTracer')
    // tracer.init();
  }

  init() {
    this.logger.debug('AnalyticsService.init', this)
    this.initialized = true
  }

  sendEvent(eventObj: QuantumMetricsEventObject) {
    if (!this.initialized) return
    this.logger.debug('AnalyticsService.sendEvent', typeof this.document.defaultView.QuantumMetricAPI, typeof this.document.defaultView.QuantumMetricAPI?.sendEvent)
    if (typeof this.document.defaultView.QuantumMetricAPI == "object" && typeof this.document.defaultView.QuantumMetricAPI.sendEvent == "function") {
      this.logger.debug('AnalyticsService.sendEvent', eventObj)
      this.document.defaultView.QuantumMetricAPI.sendEvent(
        eventObj.eventId,
        eventObj.isConversion,
        eventObj.value
      )
    }
  }

  addAction(action, context) {
    if (!this.initialized) return
    this.logger.debug('AnalyticsService.addAction', action, context)
  }

  setUserName(userName: string) {
    if (!this.initialized) return
    this.logger.debug('AnalyticsService.setUserName', userName)
  }

  async upsertChatRequest(data: any) {
    this.logger.debug('AnalyticsService.upsertChatRequest()', data);
    let url = `${ENVIRONMENT.PROPERTIES.apiUrl}${API.UPSERT_CHAT_REQUEST}/`;
    let body = {
      action: 'UPSERT_CHAT_REQUEST',
      data: data,
    }

    let response = await this.http.post(encodeURI(url), data, {
      headers: new HttpHeaders({
        'Hostname': this.authService.getHostName(),
        'Xsrf': this.authService.token ?? "abc"
      })
    }).pipe(
      catchError(err => {
        return of({ success: false })
      })
    ).toPromise()
    if (response["success"]) {
      this.logger.debug('Succeeded to upsert chat request');
    } else {
      this.logger.debug('Failed to upsert chat request');
    }

  }

  async upsertTrhNavRequest(data) {
    this.logger.debug('AnalyticsService.upsertTrhNavRequest', data);
    let url = `${ENVIRONMENT.PROPERTIES.apiUrl}${API.UPSERT_TRH_NAV_REQUEST}/`;
    let body = {
      action: 'UPSERT_TRH_NAV_REQUEST',
      data: data,
    }


    let response = await this.http.post(encodeURI(url), data, {
      headers: new HttpHeaders({
        'Hostname': this.authService.getHostName(),
        'Xsrf': this.authService.token ?? "abc"
      })
    }).pipe(
      catchError(err => {
        return of({ success: false })
      })
    ).toPromise()
    if (response["success"]) {
      this.logger.debug('Succeeded to upsert trh nav request');
    } else {
      this.logger.debug('Failed to upsert trh nav request');
    }
  }

}
